import DeleteButton from "../general/Delete";
import DeleteInvoice from "@/v2/api/invoice/Delete";

export default function InvoiceDeleteButton({
    id,
    isInside = false,
}: {
    id: string;
    isInside?: boolean;
}) {
    return (
        <DeleteButton
            id={id}
            queryKey={["invoices"]}
            deleteFn={DeleteInvoice}
            title="Delete Invoice"
            description="Are you sure you want to delete this invoice record? This action cannot be undone. Click delete to confirm."
            successTitle="Invoice Deleted Successfully"
            isInside={isInside}
        />
    );
}
